import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <Link to="/" className="navbar-logo" onClick={closeMenu}>
          🎣 Unofficial Fishing Derby
        </Link>
        <button
          className="navbar-hamburger"
          onClick={() => setMenuOpen((prev) => !prev)}
          aria-label="Toggle navigation"
          aria-expanded={menuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <ul className={`navbar-links${menuOpen ? ' open' : ''}`}>
          <li><NavLink to="/" end onClick={closeMenu}>Home</NavLink></li>
          <li><NavLink to="/register" onClick={closeMenu}>Profile & Sign In</NavLink></li>
          <li><NavLink to="/submit" onClick={closeMenu}>Submit Catch</NavLink></li>
          <li><NavLink to="/leaderboard" onClick={closeMenu}>Leaderboard</NavLink></li>
          <li><NavLink to="/community" onClick={closeMenu}>Community</NavLink></li>
          <li><NavLink to="/rules" onClick={closeMenu}>Rules & Schedule</NavLink></li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
